import React, { Component } from 'react';
import {Auth} from 'aws-amplify';

class MultiFactorAuthentication extends Component {

  state = {
    inputMFACode: ''
  }

  componentDidMount() {

  }

  render() {

    const {handleSubmit, updateInput} = this;
    const {inputMFACode} = this.state;

    return (
      <div className="MultiFactorAuthenticationPage">
        <h1>Please enter your MFA code</h1>
        <label htmlFor="inputMFACode">MFA Code</label>
        <input id="inputMFACode" value={inputMFACode} onChange={updateInput}/>
        <button onClick={handleSubmit}>Submit</button>
      </div>
    );
  }

  updateInput = e => {
    this.setState({[e.target.id]: e.target.value});
  }

  handleSubmit = () => {

    const {inputMFACode} = this.state;
    const {pushToLog, firstTimeUser, updateUserState} = this.props;

    const formattedMFACode = inputMFACode.replace(/ /g, '');

    if (formattedMFACode.length !== 6) pushToLog('MFA code must be exactly six characters long.');
    else if (/[^0-9]/.test(formattedMFACode)) pushToLog('MFA code must only contain numbers.');
    else {
      Auth.confirmSignIn(firstTimeUser, formattedMFACode, 'SOFTWARE_TOKEN_MFA')
      .then(res => {

        Auth.verifiedContact(res)
        .then(res => {
          this.setState({inputMFACode: ''});
          if (res.verified.email) {
            //email is verified
            pushToLog('Successfully logged in.');
            updateUserState({firstTimeUser: {}, challengeName: 'LOGGED_IN'});
          } else {
            //email is not verified
            pushToLog('Email address must be verified.');
            updateUserState({firstTimeUser: {}, challengeName: 'VERIFY_EMAIL'});
          }
        })
        .catch(err => {
          console.log(err);
        });

      })
      .catch(err => {
        if (err.message === 'Invalid session for the user, session is expired.') {
          pushToLog('Your session expired. Please log in again.');
          updateUserState({firstTimeUser: {}, challengeName: 'LOGGED_OUT'});
        } else if (err.message === 'Invalid code received for user') {
          pushToLog('Invalid MFA token.');
        } else {
          console.log(err);
        }
      });
    }

  }

}

export default MultiFactorAuthentication;


// WEBPACK FOOTER //
// ./src/components/content/user/userComponents/multiFactorAuthentication.js